import { render, staticRenderFns } from "./PressContacts.vue?vue&type=template&id=13b63ec0&scoped=true&"
import script from "./PressContacts.vue?vue&type=script&lang=js&"
export * from "./PressContacts.vue?vue&type=script&lang=js&"
import style0 from "./PressContacts.vue?vue&type=style&index=0&id=13b63ec0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b63ec0",
  null
  
)

export default component.exports